/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useState } from "react";

import { useTheme } from "styled-components";

import { TextBlock } from "src/classes/block/block-types";
import { StyledTextBlockContent } from "src/components/Block/BlockTypes/TextBlock/styles";
import { ViennaEditor } from "src/components/ViennaEditor";
import { getTextContent } from "src/components/ViennaEditor/lib/helpers";
import { initializeViennaEditor } from "src/components/ViennaEditor/lib/initialize";

interface Props {
  block: TextBlock;
}

export function STextBlock({ block }: Props) {
  const theme = useTheme();
  const initialValue = getTextContent(block.snapshot);
  const [editor] = useState(initializeViennaEditor());

  return (
    <StyledTextBlockContent>
      <ViennaEditor
        editor={editor}
        initialValue={initialValue}
        readOnly={true}
        textSubtype={block.snapshot.textType}
        wrapperStyles={block.getEditorStyles(theme)}
        editorId={block.textEditorId}
      />
    </StyledTextBlockContent>
  );
}
